import { render } from "./BloopLayer.vue?vue&type=template&id=6b4edac6"
import script from "./BloopLayer.vue?vue&type=script&lang=js"
export * from "./BloopLayer.vue?vue&type=script&lang=js"

import "./BloopLayer.vue?vue&type=style&index=0&id=6b4edac6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__